<footer *ngIf="currentUrl !== '/login'">
  <div>
    <p>Powered by 3D Digital Venue &copy; {{ year }} | v:{{ version }}</p>
  </div>
  <div class="d-flex align-items-center">
    <div><a href="https://3ddigitalvenue.com/privacy-policy/" target="_blank">Privacy Policy</a></div>
    <div class="ms-4"><a href="mailto:support@3ddigitalvenue.com">Contact us</a></div>
  </div>
</footer>
